import { useQuery } from '@tanstack/react-query';
import { useMemo, useRef } from 'react';
import axiosInstance from '../../axiosConfig';

const fetchMediasToQualify = async (params) => {
  const response = await axiosInstance.get('/medias/', {
    params,
  });
  return response.data;
};

const useStableParams = (params) => {
  const paramsRef = useRef(params);
  const serialized = JSON.stringify(params);
  const serializedRef = useRef(serialized);

  if (serializedRef.current !== serialized) {
    serializedRef.current = serialized;
    paramsRef.current = params;
  }

  return paramsRef.current;
};

export const useGetMediasToQualify = (params = {}, options = {}) => {
  const stableParams = useStableParams(params);

  const queryParams = useMemo(() => {
    const out = {};
    Object.entries(stableParams).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') out[k] = v;
    });
    return out;
  }, [stableParams]);

  const { data, error, isLoading, isError, refetch, isFetching } = useQuery({
    queryKey: ['medias', queryParams],
    queryFn: () => fetchMediasToQualify(queryParams),
    enabled: options.enabled ?? true,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
    retry: 2,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    refetchOnWindowFocus: false,
  });

  const medias = data?.results;
  const count = data?.count;
  const next = data?.next;
  const previous = data?.previous;

  return {
    medias,
    count,
    next,
    previous,
    error,
    isLoading,
    isError,
    isFetching,
    refetch,
  };
};
